import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";


export interface ConcreteCalculatorParams {
	pdfBlob: Blob;
	name: string;
	companyName: string;
	emailAddress: string;
	phone: string;
	message: string;
}

export interface ConcreteCalculatorApiParameter {
	rfq_pdf: Blob;
	name: string;
	company_name: string;
	email: string;
	phone: string;
	message: string;
}

export interface ConcreteCalculatorModel {
	// Define the response model here if needed
}

const concreteCalculatorApiUrl = "/api/v1/concretecalculator";

export async function concreteCalculatorService(parameter: ConcreteCalculatorApiParameter): Promise<ServiceResult<ConcreteCalculatorModel>> {
	try {
		const formData = new FormData();
		formData.append('rfq_pdf', parameter.rfq_pdf, 'Concrete Calculator.pdf');
		formData.append('name', parameter.name);
		formData.append('company_name', parameter.company_name);
		formData.append('email', parameter.email);
		formData.append('phone', parameter.phone);
		formData.append('message', parameter.message);

		const response = await fetch(concreteCalculatorApiUrl, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		const data: ConcreteCalculatorModel = await response.json();

		return {
			result: data,
			successful: true,
		};
	} catch (error) {
		if (error instanceof Response && error.status === 400) {
			const errorJson = await error.json();
			return {
				successful: false,
				errorMessage: errorJson.message,
			};
		}
		throw error;
	}
}

